module.exports = __webpack_public_path__ + "static/media/ozonehealthchest.edb007b7.jpg";